
  import {
    Component,
    Vue,
    Watch
  } from 'vue-property-decorator';
  import RadioButton from '@/components/radio-button.vue';
  import PageFooter from '@/components/page-footer.vue';
  import PickerDate from '@/components/picker-date.vue';
  import Message from '@/components/message.vue';
	import Dialog from '@/components/dialog.vue';
	import fillinlogistics from './components/fillinlogistics.vue';
  import {
    afterSalesTypes,
    afterStatus,
    afterSalesResults
  } from '@/utils/config'
  import {
    orderSupportlist,
    checkOrderRefund,
    confirmReceiveGoods,
    orderSupportremindList,
    orderSupportrefund,
    orderSupportdetail
  } from '@/api/after_sales'
	import{
		getSearchDate,
    nextDay
	}from "@/utils/index"
	import {
		UserModule
	} from "@/store/modules/user"
  import {
		lookExpress
	} from '@/api/order'
  import changeRemark from "@/views/aftersales/components/changeRemark.vue"

  @Component({
    name: 'aftersales-order',
    components: {
      RadioButton,
      PageFooter,
      PickerDate,
      'slz-message': Message,
			'slz-dialog': Dialog,
      fillinlogistics,
      changeRemark
    }
  })
  export default class AftersalesOrder extends Vue {
    private defaultThumb = 'https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png';
    private shopname = ''
    private keyword = '';
    private namephone = '';
    private salestype = 4;
    private salestypelist:any = [
      // {value:null,label:'全部'},
      {value:4,label:'未发货仅退款'},
      {value:3,label:'仅退款'},
      {value:1,label:'换货'},
      {value:2,label:'退货退款'},
      {value:5,label:'破损补寄'},
    ];
    private state = null;
    private statelist:any = [];
    private allstatelist:any = [
      {value:null,label:'全部',type:[null,1,2,3,4,5]},
      {value:0,label:'待审核',type:[1,2,3,4,5],},
      {value:10,label:'已驳回',type:[1,2,3,4,5],},
      {value:20,label:'待买家退回',type:[1,2],},
      {value:30,label:'买家已寄回',type:[1,2],},
      {value:35,label:'已确认收货退款中',type:[2],},
      {value:35,label:'审核通过退款中',type:[3,4],},
      {value:36,label:'退款失败',type:[1,2,3,4],},
      {value:40,label:'待商家寄出',type:[1,5]},
      {value:50,label:'待买家确认收货',type:[1,5]},
      {value:60,label:'已完结',type:[1,2,3,4,5],},
      {value:70,label:'已关闭',type:[1,2,3,4,5],},
    ];
    private filterTime: any = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
    private completedTime:any = ''


    private list: any = [];
    private selectType = 0

    private pageNo = 1;
    private pageSize = 10;
    private total = 0;

    private afterSalesTypes = afterSalesTypes;
    private afterSalesStatus = afterStatus;
    private afterSalesResults = afterSalesResults;
    private select: any = [{
      label: '提交时间',
      value: 0
    }]
    private selectNum: any = [{
      label: '下单编号',
      value: 0
    }]
    private currentId = 0;
    private showMessage = false;
    private showConfirmMessage = false;

    private rowmsg:any = {}
    private takeGoodsShow = false

    private fillinShow = false
    private SupportNo = ''

    private refundagainShow = false
    private refundagainloading = false
    private refundmsg:any = {
      title:'',
      content:'',
      Show:false,
      type:'warn',
      showicon:true
    }
    
    private remindShow = false
    private remindlist:any = []

    private logisticsdata:any = {}
    private logisticsmsg:any = []
    private logisticsshow = false
    private lookloading = false

    private lastpageType = 2
    
    private ReturnFreightInsuranceResponsibleParty = null
    private bannerColor = {
      0:'#f92519',
      1:'#ef8733',
      2:'#2e63f6',
      3:'#1cac34',
      4:'#873df1',
    }
    private remarkShow = false

    private mounted() {
      // this.salestypechange(null)
      // this.getList()
      this.salestypechange(this.salestype,true)
    }

    activated () {
      if(this.$route.params.time){
				this.filterTime = this.$route.params.time
			}
      this.getList()
      //首次进入页面才弹窗
      this.remindShow = false
      this.getremindlist()
    }



    private toChangeRemark(row){
      this.rowmsg = JSON.parse(JSON.stringify(row))
      this.remarkShow = true
    }
    private async confirmrefundagain(){
      try{
        this.refundagainloading = true
        let data:any = {
          SupportNo:this.rowmsg.SupportNo,
          IsModifyRemark:false,
          SystemRemark:'',
          noError:true
        }
        let res = await orderSupportrefund(data)
        if(res.IsSuccess){
          this.refundagainShow = false
          this.refundmsg = {
            title:'退款成功',
            content:res.Message,
            Show:true,
            type:'success',
            showicon:true
          }
          this.getList()
        }else{
          let res2 = await orderSupportdetail({
            SupportNo:this.rowmsg.SupportNo
          })
          let detailmsg = res2.Result
          this.refundmsg = {
            title:'退款失败',
            content:res.Message,
            Show:true,
            type:'warn',
            showicon:true,
            RefundState:detailmsg.RefundState,
            ReturnFreightInsuranceState:detailmsg.ReturnFreightInsuranceState,
          }
        }
      }catch(err){
        this.refundagainShow = false
      }finally{
        this.refundagainShow = false
        this.refundagainloading = false
      }
    }
    private refundagain(row){
      this.rowmsg = row
      this.refundagainShow = true
    }
    private looklogistics(row){
      this.logisticsshow = true
      this.logisticsdata = {
        ExpressValue:row.ReturnExpressValue,
        ExpressNo:row.ReturnExpressNo,
        address:row.ReturnReceiveProvince+row.ReturnReceiveCity+row.ReturnReceiveArea+row.ReturnReceiveAddress,
      }
      let data = {
        ExpressId:row.ReturnExpressId,
        ExpressNo:row.ReturnExpressNo,
        ReceivePhone:row.ReturnReceivePhone,
      }
      this.getlogistics(data)
    }
    private async getlogistics(data){
      try{
        this.lookloading=true
        this.logisticsmsg = []
				let res = await lookExpress(await data)
				if(res.IsSuccess){
					this.logisticsmsg = res.Result.sort((a,b)=>{
            return -1
          }).map((item, index)=>{
						item.color = index===0 ? '#0067cc':'#999';
						return item;
					})
					// console.log(this.logisticsmsg)
				}
			}finally{
        this.lookloading=false
				//
			}
    }
    private async getremindlist(){
      try{
        let res = await orderSupportremindList({
          Skip:0,
          Take:9999
        })
        if(res.IsSuccess){
          this.remindlist = res.Result
          //从确认收货的弹窗进详情出来如果有数据就弹  从列表进去的都不弹
          // console.log(UserModule.takeremind,this.lastpageType)
          if(UserModule.takeremind){
            this.lastpageType=2
          }
          if(this.lastpageType==2){
            this.remindShow = this.remindlist&&this.remindlist.length
          }else{
            this.remindShow = false
          }
        }
      }finally{
        //
      }
    }

    private showtops(){
      this.refundmsg = {
        title:'售后数量',
        content:'本次售后数量/原始订单购买商品数量',
        Show:true,
        type:'notice',
        showicon:true
      }
    }
    private salestypechange(e,isinit?:boolean){
      // console.log(e)
      this.statelist = this.allstatelist.filter(v=>{
        return v.type.includes(e)
      })
      this.state = this.statelist[0].value
      if(!isinit){
        this.doSearch()
      }
    }

    private exportlist(){
      if(this.checktime()) return
      var url = location.origin + '/provider/orderSupport/list' + 
                '?Keywords=' + (this.keyword?this.keyword:'') + 
                '&ProductName=' + (this.shopname?this.shopname:'') + 
                '&CustomerInfo=' + (this.namephone?this.namephone:'') +
                '&SupportType=' + (this.salestype?this.salestype:'') +
                '&SupportState=' + (this.state?this.state:'')
      
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				url += '&StartTime=' + dt[0];
				url += '&EndTime=' + nextDay(dt[1],1);
			}
      if(this.completedTime){
        var ct = this.completedTime.split('/');
				url += '&CompleteStartTime=' + ct[0];
				url += '&CompleteEndTime=' + nextDay(ct[1],1);
      }

      window.open(url)
    }

    private checktime(){
      if(this.completedTime&&!this.filterTime){
        this.$message.error('请同步选择售后单提交时间')
        return true
      }
      return false
    }

    private async confirmtakeGoods(){
      if((this.rowmsg.SupportType==1||this.rowmsg.SupportType==2)&&this.rowmsg.SupportState==30&&this.ReturnFreightInsuranceResponsibleParty==null
        &&this.rowmsg.ReturnFreightInsuranceMoney>0){
        this.$message.error('请选择本次售后的运费承担方！')
        return 
      }
      try{
        let res = await confirmReceiveGoods({
          SupportNo:this.rowmsg.SupportNo,
          ReturnFreightInsuranceResponsibleParty:this.ReturnFreightInsuranceResponsibleParty,
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.takeGoodsShow = false
          this.getList()
        }
      }finally{
        //
      }
    }

    private todetail(row,type){
      this.lastpageType = type
      this.$router.push({
        path:'/aftersales/detail',
        query:{
          SupportNo:row.SupportNo
        }
      })
    }


    private tofillin(row){
      this.rowmsg = row
      this.SupportNo  =row.SupportNo
      this.fillinShow = true
    }

    private takeGoods(row){
      this.rowmsg = row
      this.takeGoodsShow = true
      this.ReturnFreightInsuranceResponsibleParty = null
    }

    // private toDetail(id: number) {
    //   this.$router.push({
    //     name: 'After_Detail',
    //     query: {
    //       id: id + ''
    //     }
    //   })
    // }

    private doSearch() {
      if(this.checktime()) return
      this.pageNo = 1;
      this.getList()
    }

    private clearSearch() {
      this.shopname = ''
      this.keyword = ''
      this.namephone = ''
      // this.salestype = 1
      // this.state = 1
      this.salestypechange(this.salestype)
      this.filterTime = [getSearchDate(2,false,-29)[0],getSearchDate(2)[0]].join('/')
      this.completedTime = ''

      this.pageNo = 1;
      this.getList()
    }

    private changePage(num: number) {
      this.pageNo = num;
      this.getList();
    }

    private async getList() {
      let params: any = {
        Keywords:this.keyword,
        ProductName:this.shopname,
        CustomerInfo:this.namephone,
        SupportType:this.salestype,
        SupportState:this.state,
        Skip:(this.pageNo-1)*this.pageSize,
        Take:this.pageSize,
      }
      if (this.filterTime) {
        let time = this.filterTime.split('/');
        params.StartTime = time[0];
        params.EndTime = nextDay(time[1],1)
      }
      if (this.completedTime) {
        let time = this.completedTime.split('/');
        params.CompleteStartTime = time[0];
        params.CompleteEndTime = nextDay(time[1],1)
      }
      try {
        const res: any = await orderSupportlist(params);
        this.list = res.Result.Results || [];
        this.total = res.Result.Total;
      } catch (e) {
        console.log(e)
      }
    }

    private cancelAfterSales(id: number) {
      this.currentId = id;
      this.showMessage = true;
    }

    private confirmRefund(id: number) {
      this.currentId = id;
      this.showConfirmMessage = true;
    }

    private async confirmCancel() {
      try {
        await checkOrderRefund({
          refund_id: this.currentId,
          state: 2
        })
        this.$message({
          type: 'success',
          message: '已取消'
        })
        this.getList();
      } catch (e) {
        console.log(e)
      }
    }

    private async confirmAfterSales() {
      try {
        await checkOrderRefund({
          refund_id: this.currentId,
          state: 1
        })
        this.$message({
          type: 'success',
          message: '已确认'
        })
        this.getList();
      } catch (e) {
        console.log(e)
      }
    }
  }
